module.exports = __webpack_public_path__ + "static/img/kfQRCode.742ac25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kfQRCode.png
// module id = 4RPh
// module chunks = 0